import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import { acceptCookieConsent } from "helpers";
import { useCookieConsent } from "hooks/useCookieConsent";
import { CALENDAR_URL } from "config";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    consentPrompt: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
      padding: "24px 32px",
      background: "rgba(65, 32, 186, 0.06)",
      border: "1px solid rgba(65, 32, 186, 0.3)",
      borderRadius: 12,
      textAlign: "center",
    },
    title: {
      color: "#002F43",
      fontWeight: 700,
    },
    message: {
      color: "rgba(0, 47, 67, 0.8)",
      maxWidth: 400,
      lineHeight: 1.6,
    },
    allowButton: {
      display: "inline-block",
      padding: "10px 28px",
      background: "linear-gradient(180deg, #FFE600 0%, #FF8A00 100%)",
      borderRadius: 8,
      border: "none",
      cursor: "pointer",
      color: "#002F43",
      fontWeight: 700,
      fontFamily: "Cano, sans-serif",
      letterSpacing: 1,
      fontSize: 14,
      [theme.breakpoints.down("xs")]: {
        fontSize: 13,
        padding: "8px 20px",
      },
    },
    link: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      marginTop: 4,
      padding: "6px 0",
      background: "transparent",
      borderRadius: 8,
      color: "#4120BA",
      fontWeight: 700,
      fontFamily: "Cano, sans-serif",
      textDecoration: "underline",
      letterSpacing: 1,
      "&:hover": {
        opacity: 0.9,
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 13,
        padding: "8px 20px",
      },
    },
  }),
);

/** Google Calendar appointment scheduler with cookie consent gate. */
export default function GoogleCalendarIframe() {
  const classes = useStyles();
  const hasConsent = useCookieConsent();

  if (!hasConsent) {
    return (
      <div className={classes.consentPrompt}>
        <Typography variant="h6" className={classes.title}>
          Schedule a Meeting
        </Typography>
        <Typography variant="body1" className={classes.message}>
          To view this embedded calendar, please accept third-party cookies.
        </Typography>
        <button className={classes.allowButton} onClick={acceptCookieConsent}>
          ACCEPT COOKIES
        </button>
        <a
          href={CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          <EventIcon fontSize="small" />
          Or Open on Google Calendar
        </a>
      </div>
    );
  }

  return (
    <iframe
      src={CALENDAR_URL}
      style={{ border: "0" }}
      width="100%"
      height="1200"
      title="Google Calendar"
    />
  );
}
